<template>
    <b-modal v-model="show" title="ПАРАМЕТЕР" size="lg" :no-close-on-esc="true" :no-close-on-backdrop="true">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label>Бино фойдаланиш тури <span class="red">*</span></label>
                        <select class="form-control" v-model="dictionaryData.data.category">
                            <option value="Residential">Турар жой</option>
                            <option value="Notorious">Нотурар жой</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>Тошкент шаҳри <span class="red">*</span></label>
                        <numeric-input v-model="dictionaryData.data.rentPaymentCity" :precision="2"
                                       :class="{invalid: $v.dictionaryData.data.rentPaymentCity.$error}"
                        >

                        </numeric-input>
                    </div>
                    <div class="form-group">
                        <label>Нукус шаҳри ва вилоят марказларидаги шаҳарлар <span class="red">*</span></label>
                        <numeric-input v-model="dictionaryData.data.rentPaymentProvinceCity" :precision="2"
                                       :class="{invalid: $v.dictionaryData.data.rentPaymentProvinceCity.$error}"
                        ></numeric-input>
                    </div>
                    <div class="form-group">
                        <label>Бошқа аҳоли пунктлари <span class="red">*</span></label>
                        <numeric-input v-model="dictionaryData.data.rentPaymentOtherRegion" :precision="2"
                                       :class="{invalid: $v.dictionaryData.data.rentPaymentOtherRegion.$error}"
                        ></numeric-input>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" @click="save">
                Сақлаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="close">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>

    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import {clone} from '@/shared/utils';
    import {required, minValue} from 'vuelidate/lib/validators';
    export default {
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                dictionaryData: this.initData()
            }
        },
        validations() {
            return {
                dictionaryData: {
                    data: {
                        category: {
                            required
                        },
                        rentPaymentCity: {
                            required,
                            minValue: minValue(0.01)
                        },
                        rentPaymentProvinceCity: {
                            required,
                            minValue: minValue(0.01)
                        },
                        rentPaymentOtherRegion: {
                            required,
                            minValue: minValue(0.01)
                        }
                    }
                }
            }
        },
        methods: {
            initData() {
                return {
                    id: null,
                    dictionaryType: 'RENTAL_RATES_FOR_INDIVIDUAL',
                    data: {
                        category: null,
                        rentPaymentCity: 0,
                        rentPaymentProvinceCity: 0,
                        rentPaymentOtherRegion: 0
                    }
                }
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                const vm = this;
                this.processing = true;
                this.$http.post('dictionary/save',this.dictionaryData)
                    .then(res => {
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            vm.show = false;
                            this.$emit('change')
                        }
                        vm.processing = false;
                    },err => {
                        vm.processing = false;
                        console.log(err);
                    });
            },
            close() {
                this.show = false;
            }
        },
        created() {
            this.$eventBus.$on("showRentalRatesForIndividualModal", (data) => {
                if (data) {
                    this.dictionaryData = clone(data);
                } else {
                    this.dictionaryData = this.initData();
                }
                this.show = true;
            });
        }
    }
</script>

<style scoped>

</style>